export enum TipoProdutoEnum {
  TECNAC,
  NORMAL,
}
